export enum LocationDataHooks {
  LOCATION = 'booking-details-location',
}
